import { useLocation } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import { pageRoutes } from "../constants";

// Where the link in the verification email lands the user
const outcomes = {
  [pageRoutes.EMAIL_VERIFIED]: {
    title: "Email verified successfully 🎉",
    message: "You may close this window.",
  },
  [pageRoutes.EMAIL_VERIFICATION_FAILED]: {
    title: "We couldn’t verify your email",
    message:
      "This verification link is invalid. Please open the link in your verification email again, or contact Financeable support if it still doesn’t work.",
  },
};

export default function EmailVerified() {
  const { pathname } = useLocation();
  const { title, message } =
    outcomes[pathname.replace(/\/$/, "")] || outcomes[pageRoutes.EMAIL_VERIFICATION_FAILED];

  return (
    <>
      <Grid
        container
        item
        height="calc(100vh - 64px)"
        width="100%"
        justifyContent="center"
        alignItems="center"
        marginTop="-64px"
      >
        <Grid item xs={12} sm={6} textAlign="center" spacing={4}>
          <Typography variant="h4" sx={{ fontWeight: "bold" }}>
            {title}
          </Typography>
          <Typography variant="body1">{message}</Typography>
        </Grid>
      </Grid>
    </>
  );
}
